import { defineMessages } from 'react-intl';

export const addressMessages = defineMessages({
    street1Label: {
        id: 'address.street1Label',
        description: 'Label for an address 1 field on a US address form',
        defaultMessage: 'Address'
    },
    street2Label: {
        id: 'address.street2Label',
        description: 'Label for an address 2 field on a US address form',
        defaultMessage: 'Address 2 (optional)'
    },
    cityLabel: {
        id: 'address.cityLabel',
        description: 'Label for a city field on a US address form',
        defaultMessage: 'City'
    },
    stateLabel: {
        id: 'address.stateLabel',
        description: 'Label for a state field on a US address form',
        defaultMessage: 'State'
    },
    postalCodeLabel: {
        id: 'address.postalCodeLabel',
        description: 'Label for a postal field on a US address form',
        defaultMessage: 'ZIP'
    },
    countryLabel: {
        id: 'address.countryLabel',
        description: 'Label for a country field on an address form',
        defaultMessage: 'Country'
    },
    emailLabel: {
        id: 'address.emailLabel',
        description: 'Label for the purchaser email address field on an address form',
        defaultMessage: 'Email'
    },
    recipientFullNameLabel: {
        id: 'address.recipientFullNameLabel',
        description: 'Label for a full name field on a US address form',
        defaultMessage: '{isSelfBuy, select, true {Your Name (first and last)} other {Recipient Name (first and last)}}'
    },
    savedAddressesLabel: {
        id: 'address.savedAddressesLabel',
        description: 'Label for address selection list',
        defaultMessage: 'Saved addresses.'
    }
});
